export default "__VITE_ASSET__BcFqXx8b__"